import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "content"]
  static classes = ["hidden"]

  toggle() {
    if (this.triggerTarget.checked) {
      this.contentTarget.classList.add(this.hiddenClass)
    } else {
      this.contentTarget.classList.remove(this.hiddenClass)
    }
  }
}
